module.exports = __webpack_public_path__ + "static/logo-ef5b461c6e23c3a9cd3c067416cf5429.png";